<template>
  <div class="">
  	<!-- header start -->
    <van-nav-bar title="选择模板" left-arrow fixed :z-index="99" @click-left="onClickLeft" :border="false">
      <!-- <template #right>
        <van-icon name="share" @click="shareHandler"/> 
      </template> -->
    </van-nav-bar>
    <div class="navBarSpace"></div>
    <!-- header end -->

    <div>
      <div class="second-bar van-hairline--bottom">
        <van-button size="small" :color="isBuy ? '' : '#bbb'" class="mybtn" @click="clickIsBuy">已购买</van-button>
        <!-- <div class="selectBtn"><van-cell center title="选择类型" is-link :border="false" /></div> -->
        <div class="selectBtn">
          <van-dropdown-menu active-color="#24a378">
            <van-dropdown-item :title="typeTitle" v-model="value1" :options="option1" @change="menuChange()" />
          </van-dropdown-menu>
        </div>
        <van-button v-if="isBuy" size="small" icon="passed" class="mybtn" @click="updateTemplate()" >应用</van-button>
      </div>
      <div class="template-section">
        <van-row gutter="12">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            :offset="offset"
            :immediate-check="ischeck"
            finished-text="没有更多了"
            @load="loadMore"
          >
            <!-- 已购买模板列表 -->
            <div v-if="isBuy" class="van-clearfix">
              <van-col span="8" v-for="item in buydataList" :key="item.id">
                <div class="template-list" @click="onSelectTemplate(item)">
                  <div class="avatar">
                    <img :src="item.TemplateExtend.CoverPhoto"> 
                    <span class="date">永久</span>
                    <div v-if="isBuy" class="check">
                      <van-icon v-if="item.Id == templateid" name="success" color="#fff"/>
                    </div>
                  </div>
                  <div class="temp-content">
                    <h2 class="title">{{item.TemplateExtend.Title}}</h2>
                  </div>
                </div>
              </van-col>
            </div>
            <!-- 获取模板列表 -->
            <div v-else class="van-clearfix">
              <van-col span="8" v-for="item in dataList" :key="item.id" @click="getShowDialog(item)">
                <div class="template-list">
                  <div class="avatar">
                    <img :src="item.CoverPhoto"> 
                    <span class="date">永久</span>
                    <!-- <div v-if="isBuy" class="check">
                      <van-icon v-if="item == 2" name="success" color="#fff"/>
                    </div> -->
                  </div>
                  <div class="temp-content">
                    <h2 class="title">{{item.Title}}</h2>
                    <p class="oldprice">金额: {{item.NeedCoin}}孝爱币</p>
                    <P class="price">特价: {{item.SalesNeedCoin}}孝爱币</P>
                  </div>
                </div>
              </van-col>
            </div>
          </van-list>
        </van-pull-refresh>
          <!-- <van-col span="8" v-for="item in 10" :key="item.id" @click="isShowDialog = true">
            <div class="template-list">
              <div class="avatar">
                <img src="https://img.yzcdn.cn/vant/cat.jpeg"> 
                <span class="date">永久</span>
                <div class="check">
                  <van-icon v-if="item == 2" name="success" color="#fff"/>
                </div>
              </div>
              <div class="temp-content">
                <h2 class="title">清明时节</h2>
                <p class="oldprice">金额: 600孝爱币</p>
                <P class="price">特价: 199孝爱币</P>
              </div>
            </div>
          </van-col> -->
        </van-row>
      </div>
    </div>
    
    <!-- 预览模板弹出 -->
    <van-overlay :show="isShowDialog" :z-index="99" @click="isShowDialog = false">
      <div class="wrapper" @click.stop>
        <div class="temp-dialog">
          <img :src="showData.CoverPhoto" class="avatar"> 
          <h2 class="title">{{showData.Title}}</h2>
          <p class="oldprice">金额: {{showData.NeedCoin}}孝爱币</p>
          <P class="price">特价: {{showData.SalesNeedCoin}}孝爱币</P>
          <van-button round size="small" plain class="whitebtn" :to="{path:getyulan(),query:{id:id, img: this.showData.CoverPhoto,qimg:this.showData.ImagePath,himg:this.showData.TombstoneImagePath}}">预览</van-button>
          <van-button round size="small" plain class="whitebtn" @click="ShowDialogBuy" >购买</van-button>
          <div class="colseBtn"><van-icon size="24" color="#fff" name="cross" @click="isShowDialog = false"/></div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
	import soshm from 'soshm';
  import { Toast, Dialog } from 'vant';
  import pstatus from '@/static/sacrificePlaceTypeStatus'
	export default {
	  data() {
	    return {
        refreshing: false,
        loading: true,
        finished: false,
        offset: 100,
        ischeck: false,
        options: null,
        dataList: [],
        buydataList: [],
        keyName : "",
        isBuy: false,
        typeTitle : "选择类型",
        value1: 0,
        mid : "",
        id : 0,
        templateid : 0,
        placeType : 0,
        option1: [
          // { text: '特价', value: 0 },
          // { text: '节庆', value: 1 },
          // { text: '古典', value: 2 },
          // { text: '现代', value: 3 },
          // { text: '卡通', value: 4 },
        ],
        showData: {},
        isShowDialog: false,
        PageRows : 18,
	    };
	  },
	  components: {
    },
    methods: {
      onClickLeft() {
        this.$router.go(-1)
      },
      /**推荐给朋友**/
      // shareHandler(){
      //   soshm.popIn({
      //     title: '弹窗分享',
      //     sites: ['weixin', 'weixintimeline', 'weibo', 'qzone', 'tqq', 'qq']
      //   });
      // },
      clickIsBuy(){
        var that = this;
        this.isBuy = !this.isBuy
        this.finished = false;
        this.loading = true;
        if(this.isBuy){
          Object.assign(this.options, {
            type : "GetTemplateTemplateBuyList",
            pageIndex: 1,
            ClassId : that.value1 > 0 ? that.value1 : null,
            MemorialHallId: that.mid,
            PageRows : that.PageRows,
          });
        }else{
          Object.assign(this.options, {
            type : "GetTemplateTemplateSearchList",
            pageIndex: 1,
            ClassId : that.value1 > 0 ? that.value1 : null,
            MemorialHallId: null,
            PageRows : that.PageRows,
          });
        }
        this.getList();
      },
      getyulan(){
        
        var that = this;
        if(this.placeType == pstatus.MemorialHall){
          return '/PreMemorialHall';
        }else if(this.placeType == pstatus.MourningHall){
          return '/PreWorship';
        }else if(this.placeType == pstatus.Cemetery){
          return '/PreCemetery';
        }
      },
      init(){
        var that = this;
        that.options = {
          type: "GetTemplateTemplateSearchList",
          pageIndex: 1,
          KeyName: that.keyName,
          ClassId : that.value1 > 0 ? that.value1 : null,
          PageRows : that.PageRows,
        };
        that.getList();
      },
      loadMore() {
        var that = this;
        Object.assign(this.options, {
          pageIndex: this.options.pageIndex + 1,
          ClassId : that.value1 > 0 ? that.value1 : null,
          PageRows : that.PageRows,
        });
        this.loading = true;
        this.getList();
      },
      onRefresh() {
        var that = this;
        this.finished = false;
        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true;
        Object.assign(this.options, {
          pageIndex: 1,
          ClassId : that.value1 > 0 ? that.value1 : null,
        });
        this.getList();
      },
      getList() {
        var that = this;
        this.$store.dispatch(this.options).then(
          res => {
            console.log(res);
            that.loading = false;
            if (that.refreshing) {
              that.refreshing = false;
            }
            var dataList;
            if(that.isBuy){
              dataList = res;
            }else{
              dataList = res.TemplateList;
            }

            if (dataList.length <= 0) {
              that.finished = true;
            }

            if (dataList.length < that.PageRows){
              that.finished = true;
            }

            if (this.options.pageIndex > 1) {
              if (dataList.length > 0) {
                dataList.forEach(element => {
                  if(that.isBuy){
                    that.buydataList.push(element);
                  }else{
                    that.dataList.push(element);
                  }
                });
              }
            } 
            else {
              if(that.isBuy){
                that.buydataList = dataList;
              }else{
                that.dataList = dataList;
              }
              
            }
          },
          error => {}
        );
      },
      getTypeList(){
        var that = this;
        this.$store.dispatch({
          type: "GetTemplateTemplateTypeList",
          KeyName : that.keyName,
        }).then( res => {
          // console.log(res);
          res.map(m => {
            that.option1.push({text:m.Title, value : m.Id})
          });
        }, err =>{});
      },
      menuChange(){
        var that = this;
        this.option1.map(e => {
          if(e.value == that.value1){
            that.typeTitle = e.text;
          }
        });
        this.onRefresh();
      },
      onSelectTemplate(item){
        this.templateid = item.Id;
      },
      // 更新模板
      updateTemplate(){
        var that = this;
        this.$store.dispatch({
          type: "GetTemplateUseTemplateVue",
          AppBuyTemplateId : that.templateid,
          MemorialHallID : that.mid,
          KeyName : that.keyName,
        }).then(res => {
          Toast(res.Message);
          if(res.IsSuccess){
            this.$router.go(-1);
          }
        }, err =>{})
      },
      getShowDialog(item){
        console.log(item);
        this.showData = item;
        this.isShowDialog = true;
      },
      ShowDialogBuy(){
        var that = this;
        Dialog.confirm({message: "您确定花费"+that.showData.SalesNeedCoin+"个孝爱币，购买"+that.showData.Title+"模板吗？"})
        .then(() => {
          this.$store.dispatch({
            type: "GetTemplateBuyTemplateVue",
            AppBuyTemplateId : that.templateid,
            MemorialHallID: that.mid,
            AppTemplateId : that.showData.Id,
            BuyType : that.placeType,
          }).then(res => {
            Toast(res.Message);
            if(res.IsSuccess){
              that.isShowDialog = false;
              Toast(res.Message);
              this.$router.go(-1);
            }
          }, err =>{})
        })
        .catch(() => {});

      },
    },
    created() {
      var that = this;
      that.keyName = this.$route.query.keyName;
      that.mid = this.$route.query.mid;
      that.id = this.$route.query.id
      that.templateid = this.$route.query.templateid;
      that.placeType = this.$route.query.placeType;
      that.getTypeList();
      that.init();
    }
	};
</script>

<style scoped>
.second-bar{
  display: flex;
  align-items: center;
  padding:0 15px;
  height: 50px;
}
.selectBtn{
  flex: 1;
  margin-right: 30px;
}
.template-section{
  padding: 10px 15px;
}
.template-list .avatar{
  position: relative;
  width: 100%;
  height: 0;
  padding-top: 150%; 
  margin-bottom: 5%;
}
.template-list .avatar img{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.template-list{
  margin-bottom: 14px;
}
.template-list .date{
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0 10px;
  height: 21px;
  line-height: 21px;
  text-align: center;
  font-size: 12px;
  color: #fff;
  background-color: rgba(0,0,0,0.5);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.template-list .check{
  position: absolute;
  top: 5px;
  right: 5px;
  width: 20px;
  height: 20px;
  text-align: center;
  border-radius: 50%;
  background-color: rgba(0,0,0,0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}
.temp-content{
  text-align: center;
}
.temp-content .title{
  font-size: 14px;
  font-weight: normal;
  color: #444;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.temp-content .oldprice{
  font-size: 12px;
  color: #999;
  text-decoration: line-through;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.temp-content .price{
  font-size: 12px;
  color: #555;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.temp-dialog{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.temp-dialog>.avatar{
  width: 210px;
  height: 320px;
  object-fit: cover;
  margin-bottom: 15px;
}
.temp-dialog>.title{
  font-size: 15px;
  font-weight: normal;
  color: #fff;
  margin-bottom: 6px;
}
.temp-dialog>.oldprice{
  font-size: 12px;
  color: rgba(255,255,255,0.7);
  text-decoration: line-through;
}
.temp-dialog>.price{
  font-size: 12px;
  color: rgba(255,255,255,0.9);
  margin-bottom: 15px;
}
.temp-dialog .van-button{
  margin-bottom: 10px;
}
.temp-dialog .colseBtn{
  margin-top: 15px;
}
</style>
<style>
.selectBtn .van-dropdown-menu__item{
  justify-content: flex-start;
}
</style>